import React from 'react'
import queryContext from './context';

const useQuery = () => {
  const { config } = React.useContext(queryContext);
  return { config };
}

export default useQuery
